// Merkan · MFA-Bestätigung auf diesem Gerät merken
// Der Browser hält ein zufälliges Token, die Datenbank nur dessen Hash.
// Ob eine gemerkte Bestätigung ausreicht, entscheidet die Richtlinie des Mandanten.
import { supabase } from './supabase';

const SCHLUESSEL = 'merkan.mfa_geraet';

function lesen(): string | null {
  try {
    const w = window.localStorage.getItem(SCHLUESSEL);
    return w && w.length >= 32 ? w : null;
  } catch {
    return null;
  }
}

function neuesToken(): string | null {
  try {
    const b = new Uint8Array(32);
    crypto.getRandomValues(b);
    const token = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
    window.localStorage.setItem(SCHLUESSEL, token);
    return token;
  } catch {
    return null;
  }
}

/** Nach erfolgreicher Code-Eingabe: Gerät für den erlaubten Zeitraum merken */
export async function geraetMerken(): Promise<boolean> {
  const token = lesen() ?? neuesToken();
  if (!token) return false;
  const { data, error } = await supabase.rpc('mfa_geraet_merken', { p_token: token });
  return !error && data === true;
}

/** Gerät nicht mehr merken (z. B. öffentlicher Rechner) */
export function geraetVergessen() {
  try {
    window.localStorage.removeItem(SCHLUESSEL);
  } catch {
    /* Speicher nicht verfügbar */
  }
}

/** Neue Sitzung: gemerktes Gerät einlösen. true, wenn das Gerät bekannt ist. */
export async function geraetEinloesen(): Promise<boolean> {
  const token = lesen();
  if (!token) return false;
  const { data, error } = await supabase.rpc('mfa_geraet_einloesen', { p_token: token });
  if (error) return false;
  if (data === null) {
    geraetVergessen();
    return false;
  }
  return true;
}
